import loadable from '@loadable/component';

import brandPageQuery from './query.graphql';

const BrandPage = loadable(() =>
  import(/* webpackChunkName: "brand" */ './brand')
);

BrandPage.variables = ({ id }) => ({ id });

BrandPage.graphQL = brandPageQuery;

BrandPage.loadOrder = [{}];

export default BrandPage;
